module.exports = __webpack_public_path__ + "static/media/AW_HP_EN_1757x1080_Lemonade.c4c8349f.jpg";